import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import type { CancelActivePayload, CancelActiveResponse } from '../types';

type ServiceUserEnvelope<T> = {
  message?: string;
  status?: string;
  responseBody?: T;
  errorCode?: number;
  errorMessage?: string | null;
};

const ENDPOINT = '/user/v1/trainer-slots/parent-connect/request/cancel-active';

// Parent cancels a trainer-initiated ACTIVE parent connect (drawer
// "Cancel"). Eligibility (initiated_by == "trainer", >= 2h lead) and
// the full teardown (reminder SFNs + gcal + demo reinstatement) are
// enforced server-side; a too-late / non-trainer-initiated row comes
// back as a normal FAILURE the caller surfaces in the error modal.
export const cancelActiveParentConnect = async (
  payload: CancelActivePayload
): Promise<CancelActiveResponse> => {
  const data: ServiceUserEnvelope<CancelActiveResponse> = await axios.post(
    ENDPOINT,
    payload
  );
  return data?.responseBody ?? {};
};

export const cancelActiveParentConnectMockHandler = http.post(
  `${env.API_URL}${ENDPOINT}`,
  async ({ request }) => {
    await networkDelay();
    let sessionId = 'mock-session-id';
    try {
      const body = (await request.json()) as Partial<CancelActivePayload>;
      if (body.session_id) {
        sessionId = body.session_id;
      }
    } catch {
      /* swallow - dev-only mock */
    }
    return HttpResponse.json<ServiceUserEnvelope<CancelActiveResponse>>({
      status: 'SUCCESS',
      message: 'Parent-connect session cancelled',
      errorCode: 0,
      errorMessage: null,
      responseBody: {
        session_id: sessionId,
        session_status: 'inactive',
      },
    });
  }
);
